<div [outerHTML]="getDisplayValue()"></div>